import { TealiumClickModel } from './tealium-model.js';

export default function initTrackingEvents() {

    let tracking = {
        /**
         * Tracking event used by dom nodes with onclick attribute
         * and needed data attributes event/detail.
         *
         * @param el
         * @constructor
         */
        DomEvent(el) {
            let detail = JSON.parse(el.dataset.detail);
            console.log('🌞', el.dataset.event, detail);

            if (el.dataset.utag !== undefined) {
                let utagData = JSON.parse(el.dataset.utag);
                console.log('🌞 utag.link()', utagData);
                utag.link(utagData);
            }

            if (el.dataset.event === 'VideoClick' ||
                el.dataset.event === 'LaneClick') {

                let event = new CustomEvent(el.dataset.event, {
                    detail: detail
                });
                document.body.dispatchEvent(event);
                window.location.href = el.dataset.uri;
            }

            if (el.dataset.event === 'CTAClick') {

                let event = new CustomEvent(el.dataset.event, {
                    detail: detail
                });
                document.body.dispatchEvent(event);
                window.open(el.dataset.uri);
            }
        },
        /**
         * Tracking event executed with javascript
         *
         * @param evtName
         * @param evtDetail
         * @constructor
         */
        Event(evtName, evtDetail) {
            console.log('🌞', evtName, evtDetail);

            let event = new CustomEvent(evtName, {
                detail: evtDetail
            });
            document.body.dispatchEvent(event);
        }
    };

    window.SK = window.SK || {};
    window.SK.tracking = tracking;
}